import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class ProfileRestServices {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);
	
	getContact(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/' + params.id + '', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
	getExtraInfo(params?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/user/' + params.userId + '/extraInfo', {
			params: params,
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
	
}